module.exports = __webpack_public_path__ + "img/white-bin.8f0a9fb4.svg";